import moment from "moment";
import {
  getAreaForecastTimes,
  getForecastData,
  fishing_area_get_area_forecast_detail,
} from "../api/meteorologicalSea.js";
import { kvToJson } from "@/utils/dafaFormat.js";

function isSameDay(date1, date2) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

// 渔区点击处理函数引用，便于移除监听
const listeners = {
  onMinClick: null,
  onMaxClick: null,
  onZoom: null,
};

export default {
  state: {
    originOptions: {
      zoom: 3.4,
      center: [0, 0],
    },
    fishArea: {
      marks: {},
      forecastData: {},
    },
    layerList: [
      {
        id: "ehh-fishing-min-area-fill",
        type: "fill",
        source: "ehh-fishing-area-min",
        layout: { visibility: "none" },
        paint: { "fill-opacity": 0.5 },
      },
      {
        id: "ehh-fishing-large-area-fill",
        type: "fill",
        source: "ehh-fishing-area-large",
        layout: { visibility: "none" },
        paint: { "fill-opacity": 0.5 },
        maxzoom: 8,
      },
      {
        id: "ehh-fishing-large-area-storke",
        type: "line",
        source: "ehh-fishing-area-large",
        layout: { visibility: "none" },
        paint: {
          "line-width": ["step", ["zoom"], 1, 8, 3],
          "line-color": "#ffffff",
        },
      },
      {
        id: "ehh-fishing-large-area-text",
        type: "symbol",
        source: "ehh-fishing-area-large",
        layout: {
          "text-allow-overlap": true,
          "text-field": ["get", "code"],
          "text-pitch-alignment": "map",
          "text-rotation-alignment": "map",
          "text-size": [
            "interpolate",
            ["exponential", 1],
            ["zoom"],
            5,
            7,
            9,
            20,
          ],
          visibility: "none",
        },
        paint: {
          "text-color": "#0000FF",
        },
        minzoom: 5.4,
        maxzoom: 8,
      },
      {
        id: "ehh-fishing-min-area-storke",
        type: "line",
        source: "ehh-fishing-area-min",
        layout: { visibility: "none" },
        paint: {
          "line-width": 1,
          "line-color": "#ffffff",
        },
        minzoom: 8,
      },
      {
        id: "ehh-fishing-min-area-text",
        type: "symbol",
        source: "ehh-fishing-area-min",
        layout: {
          "text-allow-overlap": true,
          "text-field": ["get", "code"],
          "text-pitch-alignment": "map",
          "text-rotation-alignment": "map",
          "symbol-placement": "point",
          "text-size": [
            "interpolate",
            ["exponential", 1],
            ["zoom"],
            8,
            16,
            20,
            24,
          ],
        },
        paint: {
          "text-color": "#0000FF",
        },
        minzoom: 8,
      },
    ],
    // 详情数据
    weatherList: [],
    weatherData: {
      label: null,
      seaArea: null,
      value: null,
    },
    weatherShow: false,
    weatherLoading: false,
  },
  getters: {
    fishAreaWeatherList(state) {
      return state.weatherList;
    },
  },
  actions: {
    fishAreaShow({ state, dispatch }) {
      const map = window.map;
      if (!map) return;
      state.layerList.forEach((layer) => {
        if (map.getLayer(layer.id)) {
          map.setLayoutProperty(layer.id, "visibility", "visible");
        }
      });
      dispatch("fishAreaAddListener");
    },
    fishAreaHide({ state, dispatch }) {
      const map = window.map;
      if (!map) return;
      dispatch("fishAreaRemoveListener");
      state.layerList.forEach((layer) => {
        if (map.getLayer(layer.id)) {
          map.setLayoutProperty(layer.id, "visibility", "none");
        }
      });
    },
    fishAreaInit({ state, rootState }, map) {
      if (!map || window.map !== map) return;
      if (!map.getSource("ehh-fishing-area-large")) {
        map.addSource("ehh-fishing-area-large", {
          type: "geojson",
          data: window.largeFishingArea || {
            type: "FeatureCollection",
            features: [],
          },
        });
      }
      if (!map.getSource("ehh-fishing-area-min")) {
        map.addSource("ehh-fishing-area-min", {
          type: "geojson",
          data: window.minFishingAreData || {
            type: "FeatureCollection",
            features: [],
          },
        });
      }
      state.layerList.forEach((layer) => {
        if (!map.getLayer(layer.id)) {
          map.addLayer({
            ...layer,
            layout: { ...layer.layout, visibility: "none" },
          });
          if (layer.type === "fill") {
            map.setPaintProperty(
              layer.id,
              "fill-color",
              rootState.meteorological.fillColorExpressions,
            );
          }
        }
      });
    },
    fishAreaDestroy({ state }, map) {
      if (!map || !map.getLayer) return;
      state.layerList.forEach((layer) => {
        if (map.getLayer(layer.id)) {
          map.removeLayer(layer.id);
        }
      });
      if (map.getSource("ehh-fishing-area-large")) {
        map.removeSource("ehh-fishing-area-large");
      }
      if (map.getSource("ehh-fishing-area-min")) {
        map.removeSource("ehh-fishing-area-min");
      }
    },
    fishAreaGetData({ state, rootState }) {
      return new Promise((resolve, reject) => {
        getAreaForecastTimes()
          .then((response) => {
            // h5 request 返回响应体本身，业务数据在 result 字段下
            const result = response?.result || response?.data || {};
            const map = {};
            const datetimeSet = [];
            for (let values of result.v || []) {
              const [time, url] = values;
              const _time = Number(time);
              datetimeSet.push(_time);
              map[_time] = url;
            }
            const xAxisData = {};
            let lastDay = new Date("1970-01-01");
            datetimeSet.forEach((key) => {
              const _key = Number(key);
              if (isSameDay(lastDay, new Date(_key))) {
                xAxisData[_key] = "";
              } else {
                if (map[_key]) {
                  const weekday = [
                    "周日",
                    "周一",
                    "周二",
                    "周三",
                    "周四",
                    "周五",
                    "周六",
                  ];
                  const date = new Date(_key);
                  xAxisData[_key] = `${weekday[date.getDay()]} ${moment(
                    _key,
                  ).format("MM-DD")}`;
                  lastDay = date;
                }
              }
            });
            state.fishArea = {
              min: datetimeSet[0],
              max: datetimeSet[datetimeSet.length - 1],
              marks: xAxisData,
              forecastData: map,
            };
            // 同步到 meteorological.activeData 供进度条使用
            rootState.meteorological.activeData = state.fishArea;
            resolve(state.fishArea);
          })
          .catch((e) => reject(e));
      });
    },
    fishAreaOnChange({ state, rootState }, val) {
      const map = window.map;
      if (!map || !map.getSource("ehh-fishing-area-min")) return;
      const time = Object.keys(state.fishArea.forecastData).find(
        (item) => Number(item) >= Number(val),
      );
      const url = state.fishArea.forecastData[time];
      if (!url) return;
      getForecastData(url)
        .then((result) => {
          // h5 request 返回响应体本身，预报数据在 result 字段下
          const payload = result?.result || result?.data || result || {};
          const minFeatures = map.getSource("ehh-fishing-area-min")._data
            .features;
          const resultObj = (payload.v || []).reduce((res, val) => {
            const obj = Object.fromEntries(
              (payload.k || []).map((key, i) => [key, val[i]]),
            );
            res[obj.areaCode] = { ...obj };
            return res;
          }, {});
          for (let feature of minFeatures) {
            const matched = resultObj[feature.properties.code];
            feature.properties.windZLevel = matched?.windZLevel || 0;
          }
          map.getSource("ehh-fishing-area-min").setData({
            type: "FeatureCollection",
            features: minFeatures,
          });
          // 大渔区颜色取小渔区第五个
          const largeFeatures = map.getSource("ehh-fishing-area-large")._data
            .features;
          for (let feature of largeFeatures) {
            const matched = resultObj[`${feature.properties.code}-5`];
            feature.properties.windZLevel = matched?.windZLevel || 0;
          }
          map.getSource("ehh-fishing-area-large").setData({
            type: "FeatureCollection",
            features: largeFeatures,
          });
        })
        .catch(() => {});
    },
    fishAreaMapZoomEvent() {
      const map = window.map;
      if (!map) return;
      if (map.getZoom() > 8) {
        if (map.getLayer("ehh-fishing-large-area-fill")) {
          map.setLayoutProperty(
            "ehh-fishing-large-area-fill",
            "visibility",
            "none",
          );
        }
        if (map.getLayer("ehh-fishing-min-area-fill")) {
          map.setLayoutProperty(
            "ehh-fishing-min-area-fill",
            "visibility",
            "visible",
          );
        }
      } else {
        if (map.getLayer("ehh-fishing-large-area-fill")) {
          map.setLayoutProperty(
            "ehh-fishing-large-area-fill",
            "visibility",
            "visible",
          );
        }
        if (map.getLayer("ehh-fishing-min-area-fill")) {
          map.setLayoutProperty(
            "ehh-fishing-min-area-fill",
            "visibility",
            "none",
          );
        }
      }
    },
    fishAreaAddListener({ dispatch }) {
      const map = window.map;
      if (!map) return;
      listeners.onMinClick = (e) => {
        if (window.map.getZoom() > 8) {
          const data = e.features[0].toJSON().properties;
          dispatch("fishAreaHandleResultClick", {
            label: data.code,
            value: data.code,
            seaArea: data.seaArea,
          });
        }
      };
      listeners.onMaxClick = (e) => {
        if (window.map.getZoom() <= 8) {
          const data = e.features[0].toJSON().properties;
          dispatch("fishAreaHandleResultClick", {
            label: data.code,
            value: data.code,
            seaArea: data.seaArea,
          });
        }
      };
      listeners.onZoom = () => {
        dispatch("fishAreaMapZoomEvent");
      };
      map.on("click", "ehh-fishing-min-area-fill", listeners.onMinClick);
      map.on("click", "ehh-fishing-large-area-fill", listeners.onMaxClick);
      map.on("zoom", listeners.onZoom);
    },
    fishAreaRemoveListener() {
      const map = window.map;
      if (!map) return;
      if (listeners.onMinClick) {
        map.off("click", "ehh-fishing-min-area-fill", listeners.onMinClick);
      }
      if (listeners.onMaxClick) {
        map.off("click", "ehh-fishing-large-area-fill", listeners.onMaxClick);
      }
      if (listeners.onZoom) {
        map.off("zoom", listeners.onZoom);
      }
    },
    fishAreaHandleResultClick({ state }, row) {
      state.weatherData = row;
      state.weatherShow = true;
      state.weatherLoading = true;
      let areaCode = row.value;
      if (window.map && window.map.getZoom() < 8) {
        areaCode = `${row.value}-5`;
      }
      fishing_area_get_area_forecast_detail({ areaCode })
        .then((response) => {
          // h5 request 返回响应体本身，详情数据在 result 字段下
          const result = response?.result || response?.data || {};
          const element = kvToJson(result.k, result.v);
          const list = [];
          const size = 4;
          for (let i = 0; i < element.length; i += size) {
            list.push(element.slice(i, i + size));
          }
          state.weatherList = list;
          state.weatherLoading = false;
        })
        .catch(() => {
          state.weatherLoading = false;
        });
    },
    fishAreaClose({ state }) {
      state.weatherShow = false;
    },
  },
};
